import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isTokenExpired } from "../utils/token";

const GuestRoute = ({ children }) => {
  const { user } = useAuth();
  const token = localStorage.getItem("token");

  if (user && token && !isTokenExpired(token)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default GuestRoute;